import { render, staticRenderFns } from "./PledgeProducts.vue?vue&type=template&id=5665fade&"
import script from "./PledgeProducts.vue?vue&type=script&lang=js&"
export * from "./PledgeProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports